export const TOAST = {
  error: 'error',
  success: 'success',
  status: 'status',
  preview: 'preview',
};
